import { defineComponent as oe, useAttrs as ne, computed as a, ref as se, toRef as ue, openBlock as i, createElementBlock as r, mergeProps as w, normalizeClass as c, toDisplayString as b, createCommentVNode as s, createElementVNode as V, createBlock as y, resolveDynamicComponent as L, toRaw as q, withDirectives as re, toHandlers as de, unref as m, TransitionGroup as ce, withCtx as me, createVNode as ve, renderSlot as fe, nextTick as be } from "vue";
import { RevButtonIcon as he } from "@ds/components/ButtonIcon";
import { useNativeInput as ye } from "../../../composables/useNativeInput.js";
import { vFocus as xe } from "../../../directives/focus.js";
import Ce from "../../../icons/generated/IconCrossInCircleFilledSmall.vue2.js";
import ge from "../../../icons/generated/IconWarning.vue2.js";
import { useI18n as we } from "@ds/plugin";
import Ve from "../../../translations/generic.translations.js";
import { isEmpty as E } from "../../../utils/isEmpty.js";
import { omit as Be } from "../../../utils/omit.js";
import { tw as e } from "../../../utils/tailwind.js";
import { getCursorPosition as Ae } from "../InputText.helpers.js";
const Ie = ["for"], ke = ["id"], pe = ["disabled", "required", "value"], Se = ["for"], Ne = {
  key: 0,
  class: "pr-4"
}, Te = { key: 1 }, ze = ["id", "role"], He = /* @__PURE__ */ oe({
  name: "RevInputTextFixedLabel",
  inheritAttrs: !1,
  __name: "InputTextFixedLabel",
  props: {
    autofocus: { type: Boolean },
    clearButtonAriaLabel: {},
    description: {},
    disabled: { type: Boolean },
    error: {},
    format: { type: Function },
    hasClearButton: { type: Boolean },
    helperTextClass: { type: [String, Boolean, Array, Object] },
    icon: {},
    iconProps: {},
    id: {},
    inputClass: { type: [String, Boolean, Array, Object] },
    label: {},
    modelValue: {},
    size: {},
    type: {},
    required: { type: Boolean },
    startIcon: {},
    isLabelVisible: { type: Boolean },
    hasCustomAction: { type: Boolean },
    customActionIcon: {},
    inputContainerClass: { type: [String, Boolean, Array, Object] }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear", "custom-action"],
  setup(t, { expose: D, emit: R }) {
    const n = R, x = ne(), $ = a(
      () => Be(x, ["class", "style"])
    ), P = a(() => ({
      class: x.class,
      style: x.style
    })), u = se(null);
    let B = String(t.format(t.modelValue));
    const j = ue(() => t.modelValue), C = ye(u, j, {
      onInput: async (d) => {
        const f = u.value, g = d.target.value, T = f?.selectionStart ?? null, z = t.format(g), h = String(z);
        if (f && h !== g && (f.value = h, T != null)) {
          await be();
          const F = Ae(
            B,
            h,
            g,
            T
          );
          f.setSelectionRange(F, F);
        }
        B = h, n("update:modelValue", z), n("input", d);
      },
      onValidityChange: (d) => {
        d ? n("valid") : n(
          "invalid",
          u.value?.validity,
          u.value?.validationMessage ?? ""
        );
      }
    }), A = a(() => `${t.id}-input-container`);
    D({
      input: u,
      inputContainerId: A
    });
    const O = () => {
      n("input", {
        target: {
          value: ""
        }
      }), n("update:modelValue", ""), n("clear"), u.value?.focus();
    }, l = a(() => t.size === "small"), v = a(() => !E(t.error)), I = a(
      () => typeof t.modelValue == "string" ? !E(t.modelValue) : !(typeof t.modelValue > "u")
    ), o = a(
      () => v.value || C.touched.value && C.invalid.value
    ), k = a(() => !(l.value && I.value)), M = a(
      () => !l.value && t.hasClearButton && I.value
    ), p = a(() => l.value ? "" : o.value && v.value ? t.error : t.description), S = a(() => {
      if (o.value)
        return o.value && `${t.id}_error`;
    }), G = a(
      () => ({
        ...$.value,
        id: t.id,
        type: t.type,
        "aria-label": t.label,
        ...o.value ? { "aria-invalid": "true" } : {},
        ...v.value ? { "aria-describedby": S.value } : {}
      })
    ), H = we(), W = t.clearButtonAriaLabel || H(Ve.buttonClear), J = () => {
      t.hasCustomAction ? n("custom-action") : O();
    }, K = a(() => [
      e`rounded-sm relative overflow-hidden`,
      e`flex items-center gap-8`,
      e`motion-safe:transition-colors motion-safe:duration-200`,
      l.value ? [
        e`h-32 px-12`,
        e`bg-action-default-mid hover:bg-action-default-mid-hover has-[:disabled]:bg-action-default-mid-disabled`,
        e`border-none `,
        o.value ? e`focus-within:outline-danger-low focus-within:outline-2` : e`focus-within:outline-default-low focus-within:outline-2`
      ] : [
        e`h-40 pl-12 pr-6`,
        e`bg-static-default-low hover:bg-static-default-low-hover has-[:disabled]:bg-static-default-low-disabled`,
        e`border border-solid has-[:disabled]:border-action-default-low-disabled`,
        o.value ? e`border-action-danger-hi focus-within:border-action-danger-hi-pressed` : e`border-action-default-low focus-within:border-action-default-low-focus focus-within:outline-style-default-hi focus-within:outline-1 focus-within:outline-current`
      ],
      // TODO: Add missing token outline-danger-hi-pressed
      o.value && e`focus-within:outline-style-default-hi focus-within:outline-1 focus-within:outline-[#F8545B]`,
      t.inputContainerClass
    ]), Q = a(() => [
      e`group input-normalize w-full min-w-0`,
      e`focus-visible:outline-none`,
      e`bg-transparent`,
      e`truncate`,
      t.inputClass,
      l.value ? [
        e`h-32 disabled:text-onaction-default-mid-disabled`,
        o.value ? e`text-onaction-danger-mid` : e`text-onaction-default-mid`
      ] : [
        e`text-action-default-hi input-normalize h-40 disabled:text-action-default-hi-disabled`
      ]
    ]), U = a(() => [
      l.value ? e`body-1-bold` : e`body-1`
    ]), X = a(() => [
      e`body-2`,
      e`flex items-center`,
      e`mt-8`,
      t.helperTextClass,
      v.value ? e`text-static-danger-hi` : e`text-static-default-low`,
      t.disabled && e`text-static-default-low-disabled`
    ]), N = a(() => [
      l.value ? e`text-onaction-default-mid body-1-bold top-16` : e`text-action-default-hi label-large mb-8 block`,
      l.value && v.value && e`text-onaction-danger-mid`,
      e`max-w-full`,
      e`truncate`,
      t.disabled && e`text-onaction-default-mid-disabled`,
      l.value && e`pointer-events-none absolute left-[calc(0.75rem+1px)] right-12 z-[1] -translate-y-1/2`,
      !l.value && !t.isLabelVisible && e`sr-only`
    ]), Y = a(() => [
      e`pointer-events-none`,
      e`flex items-center`
    ]), Z = a(() => [
      e`pointer-events-none`,
      t.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]), _ = e`translate-x-[200%]`, ee = e`duration-300 ease-in motion-safe:transition-transform`, te = e`absolute duration-300 ease-out motion-safe:transition-transform`, ae = e`translate-x-[200%]`, le = e`duration-300 ease-out motion-safe:transition-transform`, ie = a(() => [
      e`pointer-events-none`,
      e`flex items-center`,
      t.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (d, f) => (i(), r("div", w(P.value, { class: U.value }), [
      k.value && !l.value ? (i(), r("label", {
        key: 0,
        class: c(N.value),
        for: t.id
      }, b(t.label) + b(t.required ? " *" : ""), 11, Ie)) : s("", !0),
      V("div", {
        id: A.value,
        class: c(K.value)
      }, [
        t.startIcon && !l.value ? (i(), r("div", {
          key: 0,
          class: c(ie.value)
        }, [
          (i(), y(L(q(t.startIcon)), {
            "aria-hidden": "true",
            "data-test": "startIcon",
            size: "20"
          }))
        ], 2)) : s("", !0),
        re(V("input", w({
          ref_key: "input",
          ref: u
        }, G.value, {
          class: Q.value,
          "data-test": "input-text-input",
          disabled: t.disabled,
          required: t.required,
          value: t.format(t.modelValue)
        }, de(m(C).listeners, !0)), null, 16, pe), [
          [m(xe), t.autofocus]
        ]),
        k.value && l.value ? (i(), r("label", {
          key: 1,
          class: c(N.value),
          for: t.id
        }, b(t.label) + b(t.required ? " *" : ""), 11, Se)) : s("", !0),
        l.value ? s("", !0) : (i(), y(ce, {
          key: 2,
          class: c(Y.value),
          "enter-active-class": ee,
          "enter-from-class": _,
          "leave-active-class": te,
          "leave-to-class": ae,
          "move-class": le,
          tag: "div"
        }, {
          default: me(() => [
            t.icon && !l.value ? (i(), r("div", Ne, [
              (i(), y(L(q(t.icon)), w({
                "aria-hidden": "true",
                class: Z.value,
                "data-test": "icon",
                size: "20"
              }, t.iconProps), null, 16, ["class"]))
            ])) : s("", !0),
            M.value ? (i(), r("div", Te, [
              ve(m(he), {
                "aria-label": m(W),
                class: "text-action-default-low pointer-events-auto",
                "data-test": "clear-button",
                disabled: t.disabled,
                icon: t.hasCustomAction && t.customActionIcon || m(Ce),
                size: "small",
                type: "button",
                variant: "ghost",
                onClick: J
              }, null, 8, ["aria-label", "disabled", "icon"])
            ])) : s("", !0)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 10, ke),
      fe(d.$slots, "default"),
      p.value ? (i(), r("p", {
        key: 1,
        id: S.value,
        "aria-live": "assertive",
        class: c(X.value),
        role: o.value ? "alert" : "presentation"
      }, [
        o.value ? (i(), y(m(ge), {
          key: 0,
          class: "mr-4",
          size: "20"
        })) : s("", !0),
        V("span", null, b(p.value), 1)
      ], 10, ze)) : s("", !0)
    ], 16));
  }
});
export {
  He as default
};
